import { useAdminContext } from "../context/AdminContext";

export const useAuth = () => {
  const {
    admin,
    token,
    isAuthenticated,
    isLoading,
    isInitialized,
    login,
    verifyTwoFactor,
    resendOTP,
    logout,
    refreshProfile,
  } = useAdminContext();

  return {
    admin,
    token,
    isAuthenticated,
    isLoading: isLoading || !isInitialized,
    login,
    verifyTwoFactor,
    resendOTP,
    logout,
    refreshProfile,
  };
};
